import React, { useContext, useState, useEffect } from 'react';
import { useTheme } from '@emotion/react';
import { AgendaContext } from '../../contexts/AgendaContext';
// Mui components
import { Box, Button, Typography, Skeleton } from '@mui/material';
// Components
import SolicitudCard from './SolicitudCard/SolicitudCard';
// Iconts
import iconFilter from '../../assets/icons/icon_filter-alt.svg';
// Modals
import ModalFiltrosSolicitudes from './Modals/ModalFiltrosSolicitudes';

function Solicitudes({ loadingVerificacionCD }) {
  const theme = useTheme();
  const { solicitudesContrato } = useContext(AgendaContext);

  const [solicitudesFiltradas, setSolicitudesFiltradas] = useState([]);
  const [filtroRecienteAntigua, setFiltroRecienteAntigua] = useState(true);
  const [filtroStatus, setFiltroStatus] = useState([
    'APROBADO',
    'RECHAZADO',
    'ANULADO',
    'PENDIENTE'
  ]);
  const [visibleCount, setVisibleCount] = useState(10);
  const [modalFiltroSolicitudesShow, setmodalFiltroSolicitudesShow] = useState(false);
  const [clickFiltros, setClickFiltros] = useState(false);

  const handleOpenCloseModalFiltros = () => {
    setmodalFiltroSolicitudesShow(!modalFiltroSolicitudesShow);
  };

  useEffect(() => {
    setSolicitudesFiltradas(solicitudesContrato);
  }, [solicitudesContrato]);


  const handleFilterSolicitudes = (updatedSolicitudes) => {
    setSolicitudesFiltradas(updatedSolicitudes);
  };

  const handleVerMas = () => {
    setVisibleCount((prev) => Math.min(prev + 10, solicitudesFiltradas.length));
  };

  const handleVerMenos = () => {
    setVisibleCount((prev) => Math.max(prev - 10, 10));
  };

  const handleLimpiarFiltros = () => {
    setFiltroStatus(['APROBADO', 'RECHAZADO', 'ANULADO', 'PENDIENTE']);

    setSolicitudesFiltradas(solicitudesContrato);

    setFiltroRecienteAntigua(true);
    setClickFiltros(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        gap: '1.5rem',
        flexDirection: 'column'
      }}>
      <Typography variant="h4">
        {solicitudesContrato.length > 0 ? 'Solicitudes realizadas' : 'Sin solicitudes'}
      </Typography>
      <Box>
        {solicitudesContrato.length > 0 ? (
          <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <Button
              variant="text"
              onClick={handleOpenCloseModalFiltros}
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                width: 'fit-content',
                padding: 0,
                borderRadius: 0,
                '&:hover': {
                  backgroundColor: 'transparent'
                }
              }}>
              <Box
                component="img"
                sx={{ width: '24px', height: '24px', marginRight: '0.2rem' }}
                alt="img not found"
                src={iconFilter}
              />
              <Typography variant="lists" color={theme.palette.black.main}>
                {clickFiltros ? 'Editar orden y filtro' : 'Ordenar y filtrar'}
              </Typography>
            </Button>
            {clickFiltros && (
              <Box sx={{ display: 'flex', gap: '1.5rem' }}>
                <Box
                  sx={{
                    display: 'flex',
                    fontWeight: 800,
                    fontSize: '10px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: theme.palette.white.main,
                    width: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    backgroundColor: theme.palette.pinkishRed.main
                  }}>
                  {filtroStatus.length}
                </Box>
                <Typography
                  variant="textLink"
                  onClick={handleLimpiarFiltros}
                  sx={{
                    color: theme.palette.primary.main,
                    display: 'flex',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    padding: '0px 0px 0px 1rem',
                    '&:hover': {
                      backgroundColor: 'transparent'
                    },
                    '&:focus': {
                      backgroundColor: 'transparent'
                    }
                  }}>
                  Limpiar filtros
                </Typography>
              </Box>
            )}
            <ModalFiltrosSolicitudes
              setClickFiltros={setClickFiltros}
              solicitudesPrestador={solicitudesContrato}
              setFiltroRecienteAntigua={setFiltroRecienteAntigua}
              filtroRecienteAntigua={filtroRecienteAntigua}
              solicitudesFiltradas={solicitudesFiltradas}
              setFiltroStatus={setFiltroStatus}
              filtroStatus={filtroStatus}
              modalFiltroSolicitudesShow={modalFiltroSolicitudesShow}
              handleClose={handleOpenCloseModalFiltros}
              handleFilterSolicitudes={handleFilterSolicitudes}
            />
          </Box>
        ) : (
          <Typography variant="bodyM">
            Todavía no realizaste ninguna solicitud para conectar agendas. Cuando realices una, la
            verás acá.
          </Typography>
        )}
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {loadingVerificacionCD
          ? 
            <Skeleton
              variant="rectangular"
              height={150}
              sx={{ borderRadius: '1rem' }}
            />
         
          : solicitudesFiltradas.slice(0, visibleCount).map((solicitud) => (
            <SolicitudCard solicitud={solicitud} key={solicitud.id} />
          ))}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
        {visibleCount < solicitudesFiltradas.length && (
          <Button
            variant="outlined"
            sx={{
              width: '450px',
              heigth: '3rem',
              borderRadius: '1rem',
              border: `2px solid ${theme.palette.primary.main}`,
              '&:hover': {
                backgroundColor: 'inherit',
                border: `2px solid ${theme.palette.primary.main}`,
                color: theme.palette.primary.main
              }
            }}
            onClick={handleVerMas}>
            Ver más
          </Button>
        )}
        {visibleCount === solicitudesFiltradas.length && visibleCount > 10 && (
          <Button
            variant="outlined"
            sx={{
              width: '450px',
              heigth: '3rem',
              borderRadius: '1rem',
              border: `2px solid ${theme.palette.primary.main}`,
              '&:hover': {
                backgroundColor: 'inherit',
                border: `2px solid ${theme.palette.primary.main}`,
                color: theme.palette.primary.main
              }
            }}
            onClick={handleVerMenos}>
            Ver menos
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default Solicitudes;
